
import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ExternalLink } from 'lucide-react';
import useLayoutAuth from '@/hooks/useLayoutAuth';

interface FooterProps {
  user: any;
}

const Footer: React.FC<FooterProps> = ({ user }) => {
  return (
    <footer className="bg-techne-purple text-white py-3">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-xs">
          <div>
            <h3 className="text-sm font-bold mb-1.5">Quick Links</h3>
            <ul className="space-y-0.5">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/quiz" className="text-gray-300 hover:text-white transition-colors duration-300">
                  Take Assessment
                </Link>
              </li>
              <li>
                <Link to="/insights" className="text-gray-300 hover:text-white transition-colors duration-300">
                  Insights
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-bold mb-1.5">Platform</h3>
            <ul className="space-y-0.5">
              <li>
                <Link to="/blueprint" className="text-gray-300 hover:text-white transition-colors duration-300">
                  Blueprint Course
                </Link>
              </li>
              <li>
                <a 
                  href="https://techne.ai" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center gap-1"
                >
                  Techne AI <ExternalLink size={10} />
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-bold mb-1.5">Contact</h3>
            <ul className="space-y-0.5">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-300">
                  Contact Us
                </Link>
              </li>
              <li className="flex items-start gap-1">
                <Mail size={12} className="mt-0.5 flex-shrink-0" />
                <a href="mailto:info@techne.ai" className="text-gray-300 hover:text-white">
                  info@techne.ai
                </a>
              </li>
              <li>
                <Link 
                  to="/blueprint"
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  Learn More
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-bold mb-1.5">Legal</h3>
            <ul className="space-y-0.5">
              <li>
                <a 
                  href="https://techne.ai/privacy-policy" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center gap-1"
                >
                  Terms of Service <ExternalLink size={10} />
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-2 pt-2 text-center text-xs text-gray-400">
          <p>© {new Date().getFullYear()} BoardSight AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
